// noinspection ES6UnusedImports

require('./bootstrap');
require('alpinejs');

require('../assets/plugins/chart/chart.bundle.js')
require('../assets/plugins/chart/utils.js')

require('../assets/plugins/simplebar/js/simplebar.min.js')

require('./mobile-menu');
require('./sidemenu');
// require('../assets/plugins/sidemenu-responsive-tabs/js/sidemenu')

require('../assets/js/custom.js');
require('@fortawesome/fontawesome-pro/js/all');

import Vue from 'vue';
import dayjs from "dayjs";
import summernote from 'summernote';
import 'dayjs/locale/sk';
import flatpickr from "flatpickr";
import PerfectScrollbar from 'perfect-scrollbar';


window.flatpickr = flatpickr;

var moment    = require('moment');
window.moment = moment;
require('jquery-ui/ui/widget');
require('jquery-ui/ui/scroll-parent');
require('jquery-ui/ui/data');
require('jquery-ui/ui/widgets/mouse');
require('jquery-ui/ui/ie');
require('jquery-ui/ui/widgets/sortable');

require('select2');
require('select2/dist/js/i18n/en');
require('select2/dist/js/i18n/sk');
require('select2/dist/js/i18n/cs');

const Swal = window.Swal = require('sweetalert2');

require('./jquery.print.min');

window.Sortable = require('sortablejs').Sortable;

window.cms = {
    mediaPickerCount: 0, mediaPickers: {}
};

let relativeTime = require('dayjs/plugin/relativeTime');

dayjs.extend(relativeTime);

Vue.prototype.dayjs = dayjs;
window.dayjs        = dayjs;

Object.defineProperty(Vue.prototype, '$dayjs', {value: dayjs});
let linkPicker       = require('../components/LinkPicker').default;
let imagePicker      = require('../components/ImagePicker').default;
let multiImagePicker = require('../components/MultiImagePicker').default;
let vueComponents    = {};

vueComponents['linkPicker']       = Vue.component('link-picker', linkPicker);
vueComponents['imagePicker']      = Vue.component('image-picker', imagePicker);
vueComponents['multiImagePicker'] = Vue.component('multi-image-picker', multiImagePicker);

Vue.extend(linkPicker);
Vue.extend(imagePicker);
Vue.extend(multiImagePicker);

window.vueComponents = vueComponents;

let app = new Vue({
                      el: '#app', components: {
        linkPicker, imagePicker, multiImagePicker
    }
                  });

window.vueApp = app;

$(document).ready(function () {
    $('.select2').select2(
        {
            "language"  : $('html').attr('lang'),
            escapeMarkup: function (markup) {
                return markup;
            }
        });

    const ps = new PerfectScrollbar(
        '.app-sidebar',
        {
            useBothWheelAxes: true,
            suppressScrollX : true,
        });
});

$('body').on('click', '.forceJsPrint', function (e) {
    e.preventDefault();
    $(this).doPrintPage({
                            attr: 'href', message: 'Váš dokument sa pripravuje na tlač.'
                        });
});

window.replaceCommaToDot = function (target, event) {
    $(target).val($(target).val().replace(',', '.'));
}

window.isNumberKey = function (txt, evt) {
    let charCode = (evt.which) ? evt.which : evt.keyCode;
    //console.log(charCode);
    if (charCode == 44 || charCode == 188) {
        //Check if the text already contains the . character
        if ((txt.value.indexOf(',') == -1 && txt.value.indexOf('.') == -1) && txt.value.length > 0) {
            return true;
        }
        return false;
    } else if (charCode == 46 || charCode == 190 || charCode == 110) {
        //Check if the text already contains the . character
        if ((txt.value.indexOf(',') == -1 && txt.value.indexOf('.') == -1) && txt.value.length > 0) {
            return true;
        }
        return false;
    } else {
        if ((charCode >= 48 && charCode <= 57) || (charCode >= 96 || charCode <= 105)) {
            return true;
        }
        return false;
    }
    return true;
}

window.isDecimalNumberKey = function (txt, evt) {
    let charCode = evt.which ? evt.which : evt.keyCode;

    // Allow Ctrl+V for paste
    if (evt.ctrlKey && (charCode === 86 || charCode === 118)) { // 86 = V, 118 = v
        return true;
    }

    // Replace comma with dot
    if (charCode === 188) { // 188 is the keyCode for comma
        evt.preventDefault();
        evt.target.value = evt.target.value + '.';
        return false;
    }

    // Allow numbers, dot, backspace, delete, and arrow keys
    if ((charCode >= 48 && charCode <= 57) || // Number keys
        (charCode >= 96 && charCode <= 105) || // Numpad keys
        charCode === 46 || // Delete
        charCode === 8 || // Backspace
        charCode === 190 || charCode === 110 || // Dot (period and numpad)
        (charCode >= 37 && charCode <= 40)) { // Arrow keys
        return true;
    }

    evt.preventDefault();
    return false;
}

window.handleDecimalPaste = function (txt, evt) {
    evt.preventDefault();

    let clipboardData = evt.clipboardData || window.clipboardData;
    let pastedData    = clipboardData.getData('Text');

    // Replace commas with dots and remove all non-numeric characters except for a single dot
    pastedData = pastedData.replace(/,/g, '.').replace(/[^\d.]/g, '');

    // Ensure only one dot exists in the pasted data
    let splitData = pastedData.split('.');
    if (splitData.length > 2) {
        pastedData = splitData[0] + '.' + splitData.slice(1).join('');
    }

    evt.target.value += pastedData;
}

require('./dropzine-init')